import React, { useEffect, useState } from "react";
import { Button, Form, Modal, Nav, Spinner, Tab } from "react-bootstrap";
import styles from "./LinkWalletPopup.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { addParent, getUserProfile } from "../../../lib/store/actions";
import { showToast } from "../../../helper/common";

// img

const LinkWalletPopup = ({ linkWallet, setLinkWallet, userId }) => {
  const [nameValue, setNameValue] = useState("");
  const [error, setError] = useState("");

  const handleName = (e) => {
    setNameValue(e.target.value);
  };

  const dispatch = useDispatch();

  const handleLinkWallet = () => {
    setLinkWallet(!linkWallet);
    setNameValue("");
  };
  const loading = useSelector((state) => state.Settings.loading);

  useEffect(() => {
    if (nameValue.length == 8) {
      setError("");
    }
  }, [nameValue]);

  // const handleApi = () => {
  //   dispatch(
  //     addParent({
  //       data: {
  //         parentUsername: nameValue,
  //       },
  //       callBack: (err, response) => {
  //         if (err) {
  //           return;
  //         }
  //         dispatch(
  //           getUserProfile({
  //             data: { _id: userId },
  //             callBack: (err, res) => {
  //
  //               if (err) return;
  //             },
  //           })
  //         );
  //         setNameValue("");
  //         setLinkWallet(!linkWallet);
  //         setTimeout(() => {
  //         },2000)
  //       },
  //     })
  //   );
  // };

  const handleApi = () => {
    if (nameValue.length < 8) {
      setError("Code must be exactly 8 characters");
      return;
    }
    dispatch(
      addParent({
        data: {
          parentUsername: nameValue,
        },
        callBack: (err, response) => {
          if (err) {
            console.error(err, "ERRRRRRR");
            return;
          }

          dispatch(
            getUserProfile({
              data: { _id: userId },
              callBack: (err, res) => {
                console.info(
                  "getUserProfile Response:",
                  "profileErr",
                  "profileRes",
                );
                if (err) return;
              },
            }),
          );

          // Clear input immediately
          setNameValue("");

          // Delay closing the modal
          setTimeout(() => {
            setLinkWallet(!linkWallet);
          }, 2000);
        },
      }),
    );
  };

  return (
    <>
      <Modal
        show={linkWallet}
        onHide={handleLinkWallet}
        backdrop="true"
        centered
        scrollable="true"
        className={`${styles.LinkWalletPopup} bottomPop`}
        keyboard={false}
      >
        <div className="modalWrpper">
          <Modal.Body>
            <Button
              onClick={handleLinkWallet}
              variant="transparent"
              className="border-0 p-0 position-absolute"
              style={{ top: 15, right: 15 }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                viewBox="0 0 26 26"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M13.0024 26.0048C20.1834 26.0048 26.0048 20.1834 26.0048 13.0024C26.0048 5.82137 20.1834 0 13.0024 0C5.82137 0 0 5.82137 0 13.0024C0 20.1834 5.82137 26.0048 13.0024 26.0048ZM13.0062 14.1485L18.1747 19.3251L19.3205 18.1711L14.152 13.0026L19.3205 7.83412L18.1747 6.68827L13.0062 11.8568L7.83767 6.68015L6.6837 7.83412L11.8603 13.0026L6.6837 18.1711L7.83767 19.3251L13.0062 14.1485Z"
                  fill="#506380"
                />
              </svg>
            </Button>
            <div className="top pb-3">
              <h5 className="m-0 text-white d-inline-block pb-1 fw-bold">
                {/* Link Your Parent's Wallet ID */}
              </h5>
            </div>
            <div className="contentBody pb-4">
              <Form className={`${styles.walletForm} mx-auto`}>
                <div className="px-4 pb-4 mb-3">
                  <h5 className="m-0 text-white text-center pb-1 fw-bold">
                    Link Your Parent's Wallet ID
                  </h5>
                  <div className="my-5">
                    <input
                      type="text"
                      placeholder=" Enter Parent's Wallet ID"
                      className="form-control text-white border-0"
                      style={{ background: "#1B1B26", height: 48 }}
                      value={nameValue}
                      onChange={handleName}
                    />
                    {error && <span className="text-danger">{error}</span>}
                  </div>
                  <Button
                    // disabled={isBitanicaLinked}
                    style={{ height: 50 }}
                    onClick={handleApi}
                    disabled={loading}
                    className={`${styles.submit} d-inline-flex align-items-center w-100 fw-bold justify-content-center commonBtn border-0 my-2 `}
                  >
                    {loading ? <Spinner size="sm" /> : "Submit"}
                  </Button>
                </div>
              </Form>
            </div>
          </Modal.Body>
        </div>
      </Modal>
    </>
  );
};

export default LinkWalletPopup;
